import React, { useState } from 'react';

const PartsNetCancellationDialog = ({ type, onConfirm, onCancel }) => {
	const [fields, setFields] = useState({
		cancellationReason: 'CHANGE - CUSTOMER REQUEST',
		cancellationComments: ''
	});

	const handleChange = e => {
		const { name: fieldName, value: fieldValue } = e.target;

		setFields(fields => ({
			...fields,
			[fieldName]: fieldValue
		}));
	};

	const handleConfirm = e => {
		onConfirm(fields);
	};

	return (
		<div className="overlayDialog visible" id="partsNetCancellationDialog">
			<div className="blackoutLayer"></div>
			<div className="overlayDialogWindow" style={{ width: '30em' }}>
				<h2 className="title">Cancel</h2>
				<p className="smallPush">Are you sure you want to cancel {type === 'LINE' ? 'the selected order lines' : 'this order'}?</p>
				<p>
					<label htmlFor="cancellationReason">
						<b>
							Reason for cancellation<span className="required">*</span>
						</b>
					</label>
					<select id="cancellationReason" name="cancellationReason" className="fullWidth mt-1" value={fields.cancellationReason} onChange={handleChange}>
						<option value="CHANGE - CUSTOMER REQUEST">Customer Request</option>
					</select>
				</p>
				<p>
					<label htmlFor="cancellationComments">
						<b>Comments (optional)</b>
					</label>
					<textarea
						id="cancellationComments"
						name="cancellationComments"
						className="fullWidth mt-1"
						rows={3}
						value={fields.cancellationComments}
						onChange={handleChange}
					></textarea>
				</p>
				<div className="actions">
					<button onClick={onCancel}>No</button>
					<button onClick={handleConfirm}>Yes</button>
				</div>
			</div>
		</div>
	);
};

export default PartsNetCancellationDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/partsNetOrderCancellationDialog.jsx